import React from "react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/site/motion";
import Seo from "@/components/site/Seo";
import { CERTIFICATIONS, IMAGES } from "@/data/content";

export default function Certificazioni() {
    const { t } = useLang();
    const c = t.certifications;

    return (
        <div data-testid="certifications-page">
            <Seo title={t.seo.certifications.t} description={t.seo.certifications.d} image={IMAGES.hero} path="/certificazioni" />

            <section className="relative pt-40 pb-24 bg-cb-dark cb-grid overflow-hidden">
                <div className="absolute inset-0 opacity-20">
                    <img src={IMAGES.about} alt="" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-cb-darker/80" />
                </div>
                <div className="relative max-w-7xl mx-auto px-6">
                    <Reveal className="text-cb-accent text-xs uppercase tracking-[0.3em] mb-4">{c.chapter}</Reveal>
                    <Reveal as="h1" delay={0.3} className="font-display text-5xl md:text-6xl font-bold tracking-tighter text-white">{c.title}</Reveal>
                    <Reveal delay={0.6} className="mt-6 max-w-2xl text-slate-300 text-lg">{c.sub}</Reveal>
                </div>
            </section>

            <section className="py-20 md:py-28 bg-white">
                <div className="max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {CERTIFICATIONS.map((cert, i) => {
                        const info = c.items[cert.key];
                        return (
                            <Reveal key={cert.key} delay={i * 0.25}>
                                <div data-testid={`cert-${cert.key}`} className="group h-full border border-slate-200 bg-white hover:shadow-2xl hover:shadow-black/5 hover:border-cb-accent/40 transition-all duration-300">
                                    <div className="h-44 flex items-center justify-center p-8 bg-cb-light border-b border-slate-100">
                                        <img src={cert.img} alt={info.name} loading="lazy" className="max-h-full max-w-full object-contain" />
                                    </div>
                                    <div className="p-6">
                                        <h3 className="font-display text-lg font-semibold text-cb-dark">{info.name}</h3>
                                        <p className="mt-2 text-sm text-slate-500 leading-relaxed">{info.desc}</p>
                                    </div>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </section>
        </div>
    );
}
